import { render } from "./CustomDomainAppSettingsMessage.vue?vue&type=template&id=8a9667cc&scoped=true"
import script from "./CustomDomainAppSettingsMessage.vue?vue&type=script&lang=js"
export * from "./CustomDomainAppSettingsMessage.vue?vue&type=script&lang=js"

import "./CustomDomainAppSettingsMessage.vue?vue&type=style&index=0&id=8a9667cc&scoped=true&lang=css"

import exportComponent from "/app/tmp/blackhall/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9667cc"]])

export default __exports__